import axios from "axios";

import { setClientAxiosInterceptors } from "~/utils/axios/setClientAxiosInterceptors";

export default defineNuxtPlugin({
  dependsOn: ["platform", "amplify"],
  setup: () => {
    axios.defaults.timeout = 30 * 1000;
    axios.defaults.transitional = {
      clarifyTimeoutError: true, // to get more explicit timeout errors. see: https://github.com/axios/axios/issues/1543
    };

    setUniversalAxiosInterceptors({
      axios,
      createErrorFn: createError,
    });

    setClientAxiosInterceptors(axios);
  },
});
